import { Model } from "@nozbe/watermelondb";
import { date } from "@nozbe/watermelondb/decorators";

export abstract class BaseModel extends Model {
  @date("created_at") createdAt: Date | null;
  @date("updated_at") updatedAt: Date | null;
  @date("deleted_at") deletedAt: Date | null;
}
